import Vue from "vue";
import VueRouter from "vue-router";
import joborderRoutes from "../module/joborder/joborderRoutes";
import candidateRoutes from "../module/candidate/candidateRoutes";
import commonRoutes from "../module/commonRoutes";
import adminRouter from "../module/admin/adminRouter";
import dashboardRouter from "../module/dashboard/dashboardRoutes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...joborderRoutes,
    ...candidateRoutes,
    ...commonRoutes,
    ...adminRouter,
    ...dashboardRouter
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }; // Always scroll to the top on navigation
  }
});

export default router;
